export default __webpack_public_path__ + "static/media/mimi5.ee3b0cad.gif";